// icon:basic_settings | Linea Iconset https://linea.io/ | Benjamin Sigidi
import * as React from "react";

function IconBasic_settings(props) {
  return (
    <svg viewBox="0 0 64 64" fill="gray" height="5em" width="4em" {...props}>
      <path
        fill="gray"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M36 34l5 5"
      />
      <path
        fill="gray"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={1.99998}
        d="M63 55l-5.999 6-19-19 6-6z"
      />
      <path
        fill="gray"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M12 16l6-6L8 4 6 6zM28 26L15 13M58 12.5l-8 3.75-4-4.125 3.5-8.062h0C39.5 4.062 37 9 37 14v4L3.5 52l-1.75 6 2.125 2 6.062-1.5L44 25h4c5 0 10-2.5 10-12.5h0z"
      />
    </svg>
  );
}

export default IconBasic_settings;
